import { ChangeDetectionStrategy, Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

import { map, Observable, startWith } from 'rxjs';
import { CustomIcon, IconLibrary, SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';

import { FinnairOrder } from '@fcom/dapi/api/models';
import { AspectRatios, IconPosition } from '@fcom/ui-components';
import { getCurrentBreakPoint } from '@fcom/common/utils/layout.utils';
import { Breakpoint } from '@fcom/common/interfaces';
import { CmsImageData } from '@fcom/core-api';
import { MediaQueryService, ThirdPartyAncillariesProvider } from '@fcom/common';

import { ManageBookingService } from '../../../../services/manage-booking.service';
import {
  ThirdPartyAncillariesAttributes,
  ThirdPartyDeepLink,
} from '../../../../interfaces/third-party-deep-links.interface';

@Component({
  selector: 'fin-cartrawler-airport-transfers',
  templateUrl: './cartrawler-airport-transfers.component.html',
  styleUrl: './cartrawler-airport-transfers.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CarTrawlerAirportTransfersComponent implements OnInit {
  readonly MaxImageWidth = 600;
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly IconLibrary = IconLibrary;
  readonly IconPosition = IconPosition;
  readonly CustomIcon = CustomIcon;

  deeplink$: Observable<ThirdPartyDeepLink>;
  aspectRatio$: Observable<keyof typeof AspectRatios>;

  private thirdPartyAncillaries: ThirdPartyAncillariesAttributes[] = [
    {
      partner: ThirdPartyAncillariesProvider.CAR_TRAWLER_TRANSFER,
      cmsKey: 'carTrawlerTransfer',
      partnerIcon: SvgLibraryIcon.RIDE_SHARE,
      affiliateId: 'finnair',
      campaignId: 'manage-booking',
      clientId: '396807',
      defaultStay: 7,
    },
  ];

  @Input({ required: true }) order$: Observable<FinnairOrder>;
  @Input({ required: true }) cmsImage: CmsImageData;

  constructor(
    @Inject(PLATFORM_ID) private platform: object,
    private manageBookingService: ManageBookingService,
    private mediaQueryService: MediaQueryService
  ) {}

  ngOnInit(): void {
    this.deeplink$ = this.order$.pipe(
      map((order) => {
        const leaving = order.bounds.length > 1 ? order.bounds[order.bounds.length - 1]?.departure : null;
        const arriving = order.bounds[0].arrival;

        return this.manageBookingService.getThirdPartyDeepLinks(
          order,
          arriving,
          leaving,
          this.thirdPartyAncillaries
        )[0];
      })
    );

    this.aspectRatio$ = this.mediaQueryService.getResizeEvent$().pipe(
      startWith(null),
      map(() => {
        if (isPlatformBrowser(this.platform) && getCurrentBreakPoint() === Breakpoint.MOBILE) {
          return '16x9';
        }

        return '21x9';
      })
    );
  }
}
